import { doc, updateDoc } from 'firebase/firestore'
import React from 'react'
import { db } from '../../../utitilties/firebase'
import CloseIco from '../../../assets/icons/close.png'

const TherapistsModal = ({ therapists, selectedTherapist, selectedClient, setSelectedClient, setClients }) => {

    let filteredTherapists = therapists?.filter(th => th.id != selectedTherapist?.id)



    const onSelect = async (therapistInvCode) => {

        let confirm = window.confirm('Are you sure want to move ?')

        if (!confirm) return


        const docRef = await updateDoc(doc(db, "Users", selectedClient.id), {
            invitationCode: therapistInvCode
        }).then(() => {
            setSelectedClient(false)
            setClients((clients) => clients.filter(cl => cl.id != selectedClient.id))
            alert('Moved')


        }).catch((error) => {
            console.log(error)
            alert('Error')
        })
    }



    return (
        <div style={{ display: 'flex', flexDirection: 'column' }} >

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }} >
                <h3>Select Therapist that you want to move the client to</h3>
                <img src={CloseIco} style={{ width: 25, height: 25, cursor: 'pointer' }} onClick={() => { setSelectedClient(null) }} />
            </div>

            <div style={{ margin: 10 }} >
                {filteredTherapists.map((th) =>

                    <p
                        style={{ marginTop: 10, width: '100%', padding: 10, cursor: 'pointer', border: '1px solid black' }}
                        onClick={() => onSelect(th.invitationCode)}
                    >{th?.name}</p>

                )}
            </div>
        </div>
    )
}

export default TherapistsModal